'use strict'
import {validatePhoneNumber} from './validators'

export function toggleDirtyClass(element) {
  return element.srcElement.classList.toggle('dirty', true)
}

export function setupDirtyInput(input) {
  input.addEventListener('blur', toggleDirtyClass)
  input.addEventListener('invalid', toggleDirtyClass)
  input.addEventListener('valid', toggleDirtyClass)
}

export function setupPhoneInputValidation(phoneInput) {
  return phoneInput.addEventListener('input', validatePhoneNumber)
}
